<template>
	<div class="my-reward-redeem-instructions">
		<div class="title mb-3">Instructions</div>
		<div class="description" v-html="selectedMyPayoutData.reward_data.instructions"></div>
	</div>
</template>



<script setup lang="ts">

import { computed } from "vue";
import { PayoutStore } from "@/store/PayoutStore";

const payoutStore = PayoutStore();

const selectedMyPayoutData = computed(() => {
    return payoutStore.SelectedMyPayoutData;
});

</script>